import { gql } from '@apollo/client';

export const getMailLists = gql`
  query getMailLists {
    getEmailLists {
      fields {
        key
        value
      }
      mailingLists {
        key
        value
      }
    }
  }
`;
